import React, { useState } from 'react';
import { Flexbox, Icon, Link, Typography } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import { useAuth } from '@hiiretail/core';
import { useLocation } from 'react-router-dom';

const StyledLink = styled(Link)`
  font-size: 14px;
`;

export const NoPermissionsHandlerScreen: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { permissions } = useAuth();
  const [noPermissions] = useState(
    !permissions.length || !permissions.some((permission) => permission.startsWith('iam')),
  );
  const location = useLocation();

  if (noPermissions && location.pathname !== '/profile') {
    return (
      <Flexbox container width="100%" height="100%" alignItems="center" justifyContent="center">
        <Flexbox container direction="column" gutter={4} alignItems="center">
          <Flexbox item>
            <Icon.WarningTriangle size="lg" color={() => '#F44336'} />
          </Flexbox>
          <Flexbox item container direction="column" alignItems="center">
            <Typography variant="body1">{`You don't have necessary permissions`}</Typography>
            <Typography>Please, contact your system administrator</Typography>
          </Flexbox>
          <Flexbox item container gutter={2} alignItems="flex-start">
            <Flexbox item>
              <Icon.Info size="md" />
            </Flexbox>
            <Flexbox item container direction="column" alignItems="center">
              <Typography variant="caption">
                To work with Identity and Access Management application you need to have{' '}
                <strong>iam.*</strong> permissions
              </Typography>
              <Typography variant="caption">
                You can view your permissions on the <Link to="/profile">profile</Link> page
              </Typography>
            </Flexbox>
          </Flexbox>
          <Flexbox item container direction="column" alignItems="center">
            <StyledLink to={`${window.location.origin}`} target="_self" external>
              Go back
            </StyledLink>
          </Flexbox>
        </Flexbox>
      </Flexbox>
    );
  }

  return <>{children}</>;
};
